import { addMinutes, format, startOfDay } from "date-fns";

const formatTimeLabel = (minutes) => format(addMinutes(startOfDay(new Date()), Number.parseInt(minutes)), "HH:mm");

const formatDuration = (minutes) => {
  const d = addMinutes(startOfDay(new Date()), Number.parseInt(minutes));
  const h = d.getHours();
  const m = d.getMinutes();
  return `${h ? `${h}h` : ""}${m || (m === 0 && !h) ? `${m}min` : ""}`;
};
/**
 * Format time's values number to object.
 * @param {number} num
 */
const formatNumberToOject = (num) => ({
  hours: Math.floor(num / 60),
  minutes: num % 60,
});

const convertTimeValueToNumber = (value, step) => {
  let hours = 0;
  let minutes = 0;
  if (value instanceof Date) {
    hours = value.getHours();
    minutes = value.getMinutes();
  } else if (value && (value.hours || value.minutes)) {
    hours = value.hours || 0;
    minutes = value.minutes || 0;
  } else if (!Number.isNaN(value)) {
    return Number.parseInt(value) - (value % step);
  } else if (typeof value === "string") {
    const date = new Date(value);
    hours = date.getHours();
    minutes = date.getMinutes();
  } else {
    return null;
  }
  const result = hours * 60 + minutes - ((hours * 60 + minutes) % step);
  return result;
};

export { formatTimeLabel, formatDuration, formatNumberToOject, convertTimeValueToNumber };
